import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconTrashcanRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.064 5.166A.534.534 0 0 1 10.447 5h3.111c.138 0 .276.056.383.166.107.11.172.266.172.434v.598H9.892V5.6c0-.168.065-.324.172-.434ZM8.833 8.198a1.014 1.014 0 0 0 .117 0h6.104a1.016 1.016 0 0 0 .118 0h1.275v10.2a.623.623 0 0 1-.173.434.534.534 0 0 1-.383.165H8.113a.534.534 0 0 1-.383-.165.623.623 0 0 1-.172-.434v-10.2h1.275Zm-.942-2V5.6c0-.68.263-1.34.74-1.829A2.534 2.534 0 0 1 10.446 3h3.112c.687 0 1.34.282 1.816.772.476.49.738 1.147.738 1.828v.598H19a1 1 0 0 1 0 2h-.554v10.2c0 .68-.263 1.338-.739 1.828-.477.49-1.13.771-1.817.771H8.113c-.687 0-1.34-.28-1.817-.771a2.623 2.623 0 0 1-.738-1.828v-10.2H5a1 1 0 1 1 0-2h2.891Zm2.559 4.001a1 1 0 0 1 1 1V16a1 1 0 1 1-2 0v-4.8a1 1 0 0 1 1-1Zm4.107 1a1 1 0 1 0-2 0V16a1 1 0 1 0 2 0v-4.8Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconTrashcanRound);
export default Memo;
